import React, { useEffect, useState } from 'react';
import './ForgotPassword.css';
import { Link, useNavigate } from 'react-router-dom';
import publicAxios from '../../utils/axios/publicAxios';
import Notification from '../../components/Notification/Notification';

const ForgotPassword = () => {
    const [formData, setFormData] = useState({ email: '', phoneNumber: '' });
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ type: '', message: '' });

    const navigate = useNavigate();

    const token = localStorage.getItem('token');

    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            const response = await publicAxios.post('/public/forgot-password', formData);

            if (response.status === 200) {
                navigate(`/reset-password/${response.data.userId}`);
            }

            if (response.status === 202) {
                setTimeout(() => {
                    showNotification('success', response?.data?.message || '');
                    navigate(`/confirm-otp/${response.data.userId}`);
                }, 5000);
            }

        } catch (error) {
            console.error('Forgot password error:', error.response?.data || error.message);
            showNotification('error', error.response?.data?.message || 'Password reset failed.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            navigate('/user-profile');
        }
    }, [token, navigate]);

    return (
        <div className="forgot-password">
            <Notification
                type={notification.type}
                message={notification.message}
                onClose={() => setNotification({ type: '', message: '' })}
            />

            <form className="forgot-password-form" onSubmit={handleSubmit}>
                <h2>Forgot Password</h2>

                <div className="form-group">
                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Phone Number:</label>
                    <input
                        type="tel"
                        minLength={11}
                        maxLength={11}
                        name="phoneNumber"
                        placeholder="Enter your phone number"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                    />
                </div>

                <button type="submit" className="forgot-password-btn" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit'}
                </button>
                <Link to={'/login'}>Back to login</Link>
            </form>
        </div>
    );
};

export default ForgotPassword;